import { useMemo } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import { useQuery } from "react-query";

import { CCard, CCardBody } from "@coreui/react";

import { hangHoaApi } from "src/1/apis/hang_hoa.api";
import { CIconButton } from "src/1/common/components/controls";
import { CTable } from "src/1/common/components/others";
import { TrashIcon } from "src/common/assets/icons";
import { CButton, CNumberInput, CSelect } from "src/common/components/controls";

export const Goods = ({ control, isBlock }) => {
  //#region Data

  const { data } = useQuery({
    queryKey: ["danh-sach-tat-ca-hang-hoa"],
    queryFn: () => hangHoaApi.getAll(),
    select: (response) => response?.data?.data,
  });

  const goods = useMemo(
    () =>
      data?.map(
        (e) =>
          ({
            value: e.code,
            code: e.code,
            label: e.name,
            price: e.price,
            cost: e.cost || 0,
            holiday_price: e.holiday_price,
          }) || [],
      ),
    [data],
  );

  const { fields, append, remove } = useFieldArray({
    control,
    name: "goods",
    keyName: "__id",
  });
  //#endregion

  //#region Event
  const onAdd = () => append({ code: "", new_price: 0, new_holiday_price: 0 });

  const onRemove = (index) => () => remove(index);
  //#endregion

  //#region Render
  const headers = [
    {
      key: "code",
      label: "Mã",
      align: "left",
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.code`}
          render={({ field: { value, onChange } }) => (
            <CSelect
              select="value"
              value={value}
              onChange={onChange}
              display="code"
              options={goods}
              readOnly={isBlock}
            />
          )}
        />
      ),
    },
    {
      key: "name",
      label: "Tên",
      align: "left",
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.code`}
          render={({ field: { value, onChange } }) => (
            <CSelect
              select="value"
              value={value}
              onChange={onChange}
              options={goods}
              readOnly={isBlock}
            />
          )}
        />
      ),
    },
    {
      key: "cost",
      label: "Giá cost",
      align: "right",
      width: 200,
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.code`}
          render={({ field: { value, onChange } }) => (
            <CSelect
              readOnly
              select="value"
              value={value}
              display="cost"
              options={goods}
              className="[&>input]:!text-right"
            />
          )}
        />
      ),
    },
    {
      key: "price",
      label: "Giá cũ ngày thường",
      align: "right",
      width: 200,
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.code`}
          render={({ field: { value } }) => (
            <CSelect
              readOnly
              select="value"
              value={value}
              display="price"
              options={goods}
              className="[&>input]:!text-right"
            />
          )}
        />
      ),
    },
    {
      key: "holiday_price",
      label: "Giá cũ ngày lễ",
      align: "right",
      width: 200,
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.code`}
          render={({ field: { value } }) => (
            <CSelect
              readOnly
              select="value"
              value={value}
              display="holiday_price"
              options={goods}
              className="[&>input]:!text-right"
            />
          )}
        />
      ),
    },
    {
      key: "price",
      label: "Giá mới ngày thường",
      align: "right",
      width: 200,
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.new_price`}
          render={({ field: { value, onChange } }) => (
            <CNumberInput
              value={value}
              onChange={onChange}
              disabled={isBlock}
            />
          )}
        />
      ),
    },
    {
      key: "holiday_price",
      label: "Giá mới ngày lễ",
      align: "right",
      width: 200,
      cellRender: (value, record, index) => (
        <Controller
          control={control}
          name={`goods.${index}.new_holiday_price`}
          render={({ field: { value, onChange } }) => (
            <CNumberInput
              value={value}
              onChange={onChange}
              disabled={isBlock}
            />
          )}
        />
      ),
    },
    ...(!isBlock
      ? [
          {
            key: "action",
            label: "",
            width: 70,
            bodyStyle: { padding: 0 },
            cellRender: (value, record, index) => (
              <div className="flex justify-center">
                <CIconButton
                  color="error"
                  onClick={onRemove(index)}
                  icon={<TrashIcon className="!size-5" />}
                />
              </div>
            ),
          },
        ]
      : []),
  ];
  return (
    <>
      <CCard className="!mb-[50vh]">
        <CCardBody className="px-0">
          {!isBlock && (
            <CButton onClick={onAdd} className="mb-3 mx-3">
              Thêm
            </CButton>
          )}

          <CTable headers={headers} data={fields} rowKey="__id" height={400} />
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
